<div class="rootContainer">
    <div class="cardContainer">

        <div #userAgreementContainer
             class="mt-4">
            {{ 'Pages.UserAgreement.LoadingText' | translate }}
        </div>
        
        <div class="mt-4">

            <button *ngIf="agreement"
                    class="btn btn-primary"
                    name="Operation"
                    (click)="acceptButtonClick($event)">
                {{ 'Pages.UserAgreement.AcceptButtonText' | translate }}
            </button>

        </div>

    </div>
</div>
